export enum JobAdvertisementStatusEnum {
  WAITING_FOR_ACCEPTANCE = 1,
  ACCEPTED = 2,
}
